import { VoucherList } from "@/components/accounting/VoucherList";
import { GSTInvoiceForm } from "@/components/accounting/GSTInvoiceForm";

const SalesPage = () => (
  <div className="space-y-6">
    <div className="flex items-center justify-between">
      <div>
        <h1 className="text-2xl font-bold font-display text-foreground">Sales Vouchers</h1>
        <p className="text-sm text-muted-foreground">Manage sales entries — Debit: Customer → Credit: Sales Account</p>
      </div>
      <GSTInvoiceForm type="Sales" />
    </div>
    <VoucherList type="Sales" title="Sales Vouchers" description="" hideHeader />
  </div>
);

export default SalesPage;
